<template>
  <b-modal
    id="modal-produtos"
    size="md"
    @show="showModalProdutos"
    @hidden="resetModalProdutos"
    @ok="handleOkProdutos"
    ok-only
    ok-variant="warning"
    ok-title="Continuar"
  >
    <template v-slot:modal-title>
      {{ operadora.nome }}
    </template>
    <div class="row">
      <div class="col-sm-12 col-12">
        <b-form-group :state="stateProduto" v-if="produtos.length">
          <b-form-radio
            v-for="p in produtos"
            :key="p.id"
            v-model="produtoSelecionado"
            name="produto"
            :value="p"
            :state="stateProduto"
            v-on:change="handleOkRadioProdutos()"
          >
            {{ p.nome }}
          </b-form-radio>
        </b-form-group>
        <p class="text-center" v-else-if="!loadingProdutos">
          Nenhum produto encontrado
        </p>
        <div class="text-center">
          <loader :width="'150px'" :height="'150px'" v-if="loadingProdutos" />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import lodash from "lodash";
import { mapActions, mapGetters } from "vuex"
import Loader from "@/components/Loader";

export default {
  data() {
    return {
      produtoSelecionado: null,
    }
  },
  computed: {
    ...mapGetters("share", {
      filtros: "getFiltros"
    }),
    ...mapGetters("cenario", {
      cenario: "getCenario",
      cenarios: "getCenarios",
    }),
    ...mapGetters("produto", {
      produtos: "getProdutos",
      loadingProdutos: "getLoading"
    }),
    ...mapGetters("operadora", {
      operadora: "getOperadora",
      produto: "getProduto"
    }),
    stateProduto() {
      return Boolean(this.produtoSelecionado);
    },
    parseCompulorio() {
      return this.filtros.compulsorio == 2
        ? ""
        : this.filtros.compulsorio == 1
        ? "s"
        : "n"
    },
    parseCoparticipacao() {
      return this.filtros.coparticipacao == 2
        ? ""
        : this.filtros.coparticipacao == 1
        ? "s"
        : "n"
    },
    parseRegrasAceitacao() {
      return this.filtros.regras_aceitacao
        ? "s"
        : "n";
    },
    parseAcomodacao() {
      return this.filtros.acomodacao == 2
        ? ""
        : this.filtros.acomodacao == 1
        ? "a"
        : "e"
    },
    parseCredenciado() {
      return this.filtros.credenciado
        ? this.filtros.credenciado.tipo + this.filtros.credenciado.id
        : ""
    },
    parseEntidade() {
      return this.filtros.entidade_profissao?.tipo == 'e'
        ? this.filtros.entidade_profissao.value.id
        : ''
    },
    parseProfissao() {
      return this.filtros.entidade_profissao?.tipo == 'p'
        ? this.filtros.entidade_profissao.value.id
        : ''
    },
    parseMei() {
      return this.filtros.mei == 2
        ? ""
        : this.filtros.mei == 1
        ? "s"
        : "n"
    },
  },
  methods: {
    ...mapActions(
      "operadora",
      [
        "selectedProduto",
        "selectedAdministradora",
        "selectedEntidade"
      ]
    ),
    ...mapActions(
      "produto", [
        "resetProdutos",
        "buscaProduto"
      ]
    ),
    async resetModalProdutos() {
      await this.resetProdutos()
    },
    async showModalProdutos() {
      console.log('ModalProdutos::showModalProdutos()');
      this.produtoSelecionado = null
      await this.buscaProduto({
        uf: this.filtros.cidade.uf,
        operadora: this.operadora.id,
        tipo_plano: this.filtros.tipo_plano,
        contratacao: this.filtros.contratacao,
        cidade: this.filtros.cidade ? this.filtros.cidade.id : "",
        compulsorio: this.parseCompulorio,
        coparticipacao: this.parseCoparticipacao,
        acomodacao: this.parseAcomodacao,
        regras_aceitacao: this.parseRegrasAceitacao,
        credenciado: this.parseCredenciado,
        entidade: this.parseEntidade,
        profissao: this.parseProfissao,
        faixas: this.cenario.faixas ? this.cenario.faixas : "",
        grupos_faixas: this.totalVidas(this.cenarios),
        mei: this.parseMei
      })

      if (this.produtos.length == 1) {
        this.produtoSelecionado = this.produtos[0]
        this.selectedProduto(this.produtoSelecionado)
        this.$bvModal.hide("modal-operadora-produtos");
        this.$bvModal.hide("modal-produtos");
        this.$bvModal.show("modal-produto-grupos");
      }
    },
    totalVidas(cenarios) {
      var grupos_faixas = [];
      cenarios.forEach(cenario => {
        cenario.faixas.forEach(faixa => {
          let key = grupos_faixas.findIndex(gf => gf.slug == faixa.slug)
          if (key != -1) {
            grupos_faixas[key].value = parseInt(grupos_faixas[key].value||0) + parseInt(faixa.value||0);
          } else {
            grupos_faixas.push(JSON.parse(JSON.stringify(faixa)));
          }
        })
      });
      return grupos_faixas
    },
    handleOkProdutos(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmitProduto();
    },
    checkFormValidityProduto() {
      return this.produtoSelecionado !== null;
    },
    handleSubmitProduto() {
      if (!this.checkFormValidityProduto()) {
        return;
      }
      this.$nextTick(() => {
        this.selectedProduto(this.produtoSelecionado)
        this.$bvModal.hide("modal-produtos");
        this.$bvModal.show("modal-produto-grupos");
      });
    },
    handleOkRadioProdutos() {
      this.handleSubmitProduto();
    }
  },
  components: {
    Loader
  }
}
</script>
<style></style>